import {
  Box,
  Button,
  MenuItem,
  Stack,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Layout } from "../dashboard/dashboard";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DataTable from "./ClientTable";
import CustomDialogue from "../reuseableComp/Modal";
import { Typo } from "../payment";
import { Back, ClientLogo } from "../../assets/Svg";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import {
  getBills,
  getBillsOfClient,
  getClient,
  getClientById,
  getCountry,
  getCustomerLedgers,
  getData,
  saveClient,
  updateClient,
} from "../../apiservices";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SimpleTable from "./SimpleTable";
import ReactToPrint from "react-to-print";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Search from "../searchBar";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { formatDate } from "../general";

const Btn = styled(Button)({
  minWidth: "126px",
  height: "36px",
  padding: "4px",
  borderRadius: "4px",
  textTransform: "none",
  background: "#FFFFFF",
  color: "#05ae97",
  marginRight: 10,
  "&:hover": {
    background: "#F6F6F6",
  },
  "&:active": {
    background: "#FFFFFF",
  },
});
export const BackBtn = styled(Button)({
  minWidth: "100px",
  height: "30px",
  padding: "4px",
  borderRadius: "4px",
  textTransform: "none",
  background: "#FFFFFF",
  color: "#05ae97",
  marginRight: 10,
  "&:hover": {
    background: "#F6F6F6",
  },
  "&:active": {
    background: "#FFFFFF",
  },
});
export const Lay = styled(Stack)({
  // width: "700px",
  height: "40px",
  borderRadius: "8px",
  // border: " 0px 0px 1px 0px",
  background:
    "linear-gradient(0deg, #9F9E9E, #9F9E9E) linear-gradient(0deg, #FFFFFF, #FFFFFF)",
  borderBottom: "1px solid #9F9E9E",
  borderLeft: "1px solid #9F9E9E",
  borderRight: "1px solid #9F9E9E",
});
export const CustomField = styled(TextField)({
  mb: 2,
  background: "#F6F6F6",
  borderRadius: "10px",
  boxShadow: "rgb(77, 175, 81) 0px 3px 7px",
  "& label.Mui-focused": {
    color: "#05ae97",
  },

  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#05ae97",
    },
    "&:hover fieldset": {
      borderColor: "#05ae97",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#05ae97",
    },
  },
});
export const schema = yup
  .object({
    fName: yup.string().required(),
    address: yup.string().required(),
    num: yup.string().required(),
  })
  .required();
const Client = () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const componentRef = useRef();
  const [state, setState] = useState({
    openModal: false,
    clientData: [],
    check: false,
    updatedData: [],
    ledgerData: {},
    clientDataById: [],
    cityArr: [],
    city: "",
    opening_balance: 0,
    searchData: [],
    clientName: "",
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const handleModal = (data = "") => {
    setState((prev) => ({
      ...prev,
      openModal: !prev.openModal,
      check: false,
      updatedData: data,
      opening_balance: data?.opening_balance,
      clientName: data.client_name,
    }));
    if (data) {
      console.log(data)
      setState((prev) => ({ ...prev, city: data.country_id }));
      setValue("address", data.address);
      setValue("num", data.contact);
      setValue("fName", data.client_name);
    }
  };
  const getClientsData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    let obj = {

    };
    let res = await getCustomerLedgers(obj);
    if (res.success) {
      const data = res.data.map(x => {
        return ({
          ...x,
          balance: (parseInt(x.opening_balance) + parseInt(x.debit) - parseInt(x.credit))
        })
      })
      setState((prev) => ({
        ...prev,
        clientData: data
      }));
    }
    else {
      setState((prev) => ({
        ...prev,
        clientData: [],
      }));
    }
  };
  useEffect(() => {
    getClientsData();
    getCount();
  }, []);

  const viewLedger = async (data = "") => {
    // console.log(data)
    if (data && data.id) {
      // getClientData(data);
      const pDataObj = {
        table: "payments",
        filters: [
          {
            column_name: "client_id",
            operation: "=",
            value: data.id
          }
        ],
      }
      const paymentRes = await getData(pDataObj)
      // console.log("paymentRes", paymentRes)

      const saleRes = await getBillsOfClient(data.id)
      // console.log("saleRes", saleRes)

      let balance = []
      balance.push({
        date: "",
        details: `Opening Balance`,
        debit: 0,
        credit: 0,
        closing: data.opening_balance
      })
      for (var d = new Date('2024-03-01'); d <= new Date(); d.setDate(d.getDate() + 1)) {
        if (saleRes && saleRes.data && saleRes.data.length) {
          saleRes.data.map((element) => {
            if (formatDate(element.date) == formatDate(d)) {
              balance.push({
                date: element.date,
                details: element && (element.voucher_no.toString().length == 1 ? "Invoice#00" : element.voucher_no.toString().length == 2 ? "Invoice#0" : "Invoice#") + element.voucher_no,
                debit: element.amount,
                credit: 0
              })
            }
          })
        }
        if (paymentRes && paymentRes.data && paymentRes.data.length) {
          // console.log("d--------------------", formatDate(d));
          paymentRes.data.map((element) => {
            if (formatDate(element.date) == formatDate(d)) {
              balance.push({
                date: element.date,
                details: element && (element.id.toString().length == 1 ? "Payment #00" : element.id.toString().length == 2 ? "Payment#0" : "Payment#") + element.id,
                debit: 0,
                credit: element.amount
              })
            }
          })
        }
      }
      if (balance && balance.length) {
        for (let i = 0; i < balance.length; i++) {
          if (i == 0) {
            balance[i].closing = parseFloat(data.opening_balance) + parseFloat(balance[i].debit) - parseFloat(balance[i].credit)
          }
          else {
            balance[i].closing = parseFloat(balance[i - 1].closing) + parseFloat(balance[i].debit) - parseFloat(balance[i].credit)
          }
        }
      }

      // console.log("balance", balance)

      setState((prev) => ({
        ...prev,
        ledgerData: balance,
        clientData: data
      }));
    }
    else{
      getClientsData()
    }
    setState((prev) => ({
      ...prev,
      viewLedger: !prev.viewLedger,
    }));
  };
  const onSubmit = async (data) => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (state.check) {
      let obj = {
        company_code: userData.company_code,
        client_name: data.fName,
        opening_balance: state.opening_balance,
        country_id: state.city,
        contact: data.num,
        address: data.address,
        updated_by: userData.id
      };
      let res = await updateClient(obj, state.updatedData.id);
      if (res) {
        toast.success("client updated successfully");
        getClientsData();
        handleModal();
      }
    } else {
      let obj = {
        company_code: userData.company_code,
        client_name: data.fName,
        country_id: state.city,
        contact: data.num,
        address: data.address,
        opening_balance: state.opening_balance,
        added_by: userData.id
      };
      let res = await saveClient(obj);
      if (res) {
        toast.success("client saved successfully");
        getClientsData();
        handleModal();
      }
    }
  };
  const handleCheck = () => {
    setState((prev) => ({ ...prev, check: !prev.check }));
  };
  const getCount = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    let arr = [];
    let obj = {
      company_code: userData.company_code,
    };
    let res = await getCountry(obj);
    if (res.success) {
      // res.data.map((item) => arr.push(item.city_name));
      setState((prev) => ({ ...prev, cityArr: res.data }));
    }
  };
  const handleChange = (e) => {
    let { name } = e.target;
    let { value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const ComponentToPrint = React.forwardRef((props, ref) => (
    <Stack id="content-to-print" ref={ref} sx={{ padding: 3 }}>
      <Stack sx={{ mb: 3 }}>
        <Lay
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            paddingLeft: 2,
            paddingRight: 2,
            mt: 5,
            borderTop: "1px solid #9F9E9E",
          }}>
          <Typography>Client Name:</Typography>
          <Typography>{state.clientData.client_name}</Typography>
        </Lay>
        <Lay
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ paddingLeft: 2, paddingRight: 2 }}>
          <Typography>Contact Number:</Typography>
          <Typography>{state.clientData.contact}</Typography>
        </Lay>
        {/* <Lay
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ paddingLeft: 2, paddingRight: 2 }}>
          <Typography>City:</Typography>
          <Typography>{state.clientData.city_name}</Typography>
        </Lay> */}

        <Lay
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ paddingLeft: 2, paddingRight: 2 }}>
          <Typography>Current Balance:</Typography>
          <Typography>{parseFloat(state.clientData.opening_balance) + parseFloat(state.clientData.debit) - parseFloat(state.clientData.credit)}</Typography>
        </Lay>
      </Stack>
      <SimpleTable
        data={state.clientDataById?.clientArray}
        clientData={state.ledgerData}
        ledgerData={state.ledgerData}
      />
      <Lay
        direction={fullScreen ? "column" : "row"}
        alignItems={"center"}
        justifyContent={"space-around"}
        sx={{ paddingRight: 2, mt: fullScreen ? 4 : 1 }}>
        <Stack direction={"row"} sx={{ mx: 2 }}>
          <Typography>Total Sale:</Typography>
          <Typography>{` Rs ${state.clientData.debit}`}</Typography>
        </Stack>
        <Stack direction={"row"} sx={{ mx: 2 }}>
          <Typography>Total Payment:</Typography>
          <Typography>{` Rs ${state.clientData.credit}`}</Typography>
        </Stack>
        <Stack direction={"row"} sx={{ mx: 2 }}>
          <Typography>Balance:</Typography>
          <Typography> Rs {parseFloat(state.clientData.opening_balance) + parseFloat(state.clientData.debit) - parseFloat(state.clientData.credit)}</Typography>
        </Stack>
      </Lay>
    </Stack>
  ));
  const updateData = (data) => {
    setState((prev) => ({ ...prev, clientData: data }));
  };
  const handleOnSearch = (string) => {
    setState((prev) => ({ ...prev, clientName: string }));
  };
  const handleOnSelect = (item) => {
    setState((prev) => ({ ...prev, clientName: item.brand }));
  };
  return (
    <Stack sx={{ paddingLeft: 2, paddingRight: 2 }}>
      {state.viewLedger ? (
        <Stack>
          <Layout justifyContent="end" alignItems={"center"} direction={"row"}>
            {/* <ReactToPrint
              trigger={() => (
                <Btn>
                  <PictureAsPdfIcon fontSize="small" sx={{ mx: 1 }} />
                  {!fullScreen && "PDF"}
                </Btn>
              )}
              content={() => componentRef.current}
            /> */}

            <ReactToPrint
              trigger={() => (
                <Btn>
                  <PrintIcon fontSize="small" sx={{ mx: 1 }} />
                  {!fullScreen && "Print"}
                </Btn>
              )}
              content={() => componentRef.current}
            />
             <Btn onClick={viewLedger}>
              <Back sx={{ mx: 1 }} />
              {!fullScreen && "Back"}
            </Btn>
          </Layout>
          <ComponentToPrint ref={componentRef} />
        </Stack>
      ) : (
        <>
          <Layout
            justifyContent="space-between"
            alignItems={"center"}
            direction={"row"}>
            <Typography
              sx={{
                color: "#000",
                fontSize: "24px",
                fontWeight: 700,
              }}></Typography>
            <Typography
              sx={{ color: "#000", fontSize: "24px", fontWeight: 700 }}>
              Clients
            </Typography>
            <Btn onClick={handleModal}>
              <AddCircleIcon fontSize="small" sx={{ mx: 1 }} /> Add new client
            </Btn>
          </Layout>
          <Stack sx={{ padding: "20px" }}>
            <DataTable
              editLedger={(data) => handleModal(data)}
              data={state.clientData}
              handleCheck={handleCheck}
              getData={getClientsData}
              viewLedger={(data) => viewLedger(data)}
            />
          </Stack>
        </>
      )}
      <CustomDialogue
        open={state.openModal}
        handleClose={handleModal}
        header={
          <Stack justifyContent={"center"} alignItems={"center"}>
            <Box sx={{ color: "#05ae97" }}>
              <ClientLogo />
            </Box>
            <Typo>Add new Client</Typo>
          </Stack>
        }
        content={
          <Stack sx={{ padding: 1 }}>
            <Stack sx={{ mb: 2 }}>
              {/* <ReactSearchAutocomplete
                styling={{
                  mb: 2,
                  background: "#F6F6F6",
                  borderRadius: "10px",
                  boxShadow: "rgb(77, 175, 81) 0px 3px 7px",
                  zIndex: 9999,
                }}
                items={state.clientData}
                onSearch={handleOnSearch}
                onSelect={handleOnSelect}
                autoFocus
                inputSearchString={state.clientName}
                showItemsOnFocus={true}
              /> */}
              <CustomField
                id="outlined-select-currency"
                label="Client Name"
                {...register("fName")}
                sx={{
                  background: "#F6F6F6",
                  "& label.Mui-focused": {
                    color: "#05ae97",
                  },
                }}
              />
              {errors.fName && (
                <p style={{ color: "red" }}>{errors.fName?.message}</p>
              )}
            </Stack>

            <Stack sx={{ mb: 2 }}>
              <CustomField
                fullWidth
                id="outlined-select-currency"
                label="Mobile Number"
                {...register("num")}
                sx={{
                  background: "#F6F6F6",
                  "& label.Mui-focused": {
                    color: "#05ae97",
                  },
                }}
              />
              {errors.num && (
                <p style={{ color: "red" }}>{errors.num?.message}</p>
              )}
            </Stack>
            {/* <Stack sx={{ mb: 2 }}>
              <CustomField
                fullWidth
                id="outlined-select-currency"
                label="City"
                select
                name="city"
                value={state.city}
                onChange={handleChange}
                sx={{
                  background: "#F6F6F6",
                  "& label.Mui-focused": {
                    color: "#05ae97",
                  },
                }}>
                {state.cityArr.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.city_name}
                  </MenuItem>
                ))}
              </CustomField>
            </Stack> */}
            <Stack sx={{ mb: 2 }}>
              <CustomField
                fullWidth
                id="outlined-select-currency"
                label="Address"
                {...register("address")}
                sx={{
                  background: "#F6F6F6",
                  "& label.Mui-focused": {
                    color: "#05ae97",
                  },
                }}
              />
              {errors.address && (
                <p style={{ color: "red" }}>{errors.address?.message}</p>
              )}
            </Stack>
            <Stack sx={{ mb: 2 }}>
              <CustomField
                fullWidth
                id="outlined-select-currency"
                label="Opening Balance"
                name="opening_balance"
                value={state.opening_balance}
                onChange={handleChange}
                sx={{
                  background: "#F6F6F6",
                  "& label.Mui-focused": {
                    color: "#05ae97",
                  },
                }}></CustomField>
            </Stack>
            <Stack spacing={3} direction={"row"}>
              <Button
                onClick={handleModal}
                size="small"
                sx={{
                  background: "#FFF",
                  width: "200px",
                  textTransform: "none",

                  color: "#9F9E9E",
                  "&:hover": {
                    background: "#EFEFEF",
                  },
                }}>
                Cancel
              </Button>
              <Button
                size="small"
                onClick={handleSubmit(onSubmit)}
                sx={{
                  width: "200px",
                  textTransform: "none",
                  background: "#05ae97",
                  color: "#000",
                  "&:hover": {
                    background: "#61D140",
                  },
                }}>
                {state.check ? "Update Client" : " Save Client"}
              </Button>
            </Stack>
          </Stack>
        }
      />
    </Stack>
  );
};

export default Client;
